import { Injectable, NgZone } from '@angular/core';
import { L2 } from 'l2-lib/L2'
import { BehaviorSubject } from 'rxjs';
import { MsgDialog } from '~/dialogs/msg-dialog.component';
import { PwaService } from '~/shared/pwa.service';
import { ProfileService } from '~/profile/profile.service';

export class AddressWithComponents {
  Country: string;
  Province: string;
  Town: string;
  Suburb: string;
  Street: string;
  StreetNumber: string;
  UnitNumber: string;
}

@Injectable()
export class TmhService {

  public data?: {
    FromAddressComponents?: AddressWithComponents,
    ToAddressComponents?: AddressWithComponents,
    PickupDateTimeLocal: Date | moment.Moment;
    AssignedSP: string; MainContactPerson: string; TeamNum: string;
    HasPassengers: string;
    NumberOfPassengers: string;
    PickupLocationType: string;
    From: string;
    FromLat: number;
    FromLatOld: number; 
    FromLong: number; 
    FromLongOld: number;
    To: string; 
    ToLat: number; 
    ToLatOld: number;
    ToLong: number; 
    ToLongOld: number;
    DistanceInKm: number; 
    ContactNo: string, 
    ContactPerson: string;
    MemberConfirmationRequired: boolean;
    IsTmhNow: boolean;
  };
  public isRecalcingDistance: boolean = false;

  public ioaRef: string;
  public shortId: string;

  public _isLocationSupported: boolean = false;
  public _isLocationDenied: boolean = false;


  constructor(private zone: NgZone, public pwaService: PwaService, private profileService: ProfileService) {

    this.pwaService.capabilitiesChanged$.subscribe(caps => {
      this._isLocationSupported = caps.location;
      this._isLocationDenied = caps.locationDenied;
    });

  }

  private _pickupNOW: boolean = false;
  public isResolvingCurrentLocation: boolean = false;

  set pickupNOW(now: boolean) {
    this._pickupNOW = now;

    if (now) {

      if (!this.isResolvingCurrentLocation) {

        this.resolveCurrentLocation();
      }

    }
    else if (this.isResolvingCurrentLocation) {
      // cancel resolve process
    }
  }

  get pickupNOW(): boolean {
    return this._pickupNOW;
  }

  private resolveCurrentLocation() {
    try {

      if (this._isLocationDenied || !this._isLocationSupported) {
        this.isResolvingCurrentLocation = false;
        return;
      }

      this.isResolvingCurrentLocation = true;

      this.pwaService.getCurrentPosition().then((pos: Position) => {

        // resolve lat/long of current location to a proper address (reverse geocode search)
        new google.maps.Geocoder().geocode({ location: new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude) }, (res, status) => {
          if (status == google.maps.GeocoderStatus.OK && res.length > 0) {

            //this.analytics.event(`TMH.Location${this._type}`, "MyLocationSelected.Success");

            let lat = res[0].geometry.location.lat();
            let lng = res[0].geometry.location.lng();

            this.updateLocation(0/*From Location*/, { description: res[0].formatted_address, address_components: res[0].address_components, lat: lat, long: lng }).then(r => {
              if (r) {

                this.zone.run(() => {
                  this.isResolvingCurrentLocation = false;
                });

              }
            });
          }
          else {
            //this.analytics.event(`TMH.Location${this._type}`, "MyLocationSelected.NotOK");
            //MsgDialog.exclamation(this.dialog, "", "Failed to resolve current location. Please try again.");

          }
        });


      }).catch(err => {
        this.isResolvingCurrentLocation = false;
        console.error(err);
        //this.analytics.event(`TMH.Location${this._type}`, "MyLocationSelected.Error");
        //MsgDialog.exclamation(this.dialog, "", "Failed to retrieve current location. Please try again.");
      });

    }
    catch (e) {
      console.error(e);
      this.isResolvingCurrentLocation = false;
    }
  }


  private findAddressComponent(address_components: google.maps.GeocoderAddressComponent[], componentType: string): string {
    let f = address_components.find(r => r.types.indexOf(componentType) >= 0);

    if (f) {
      // if (this.data.FromLat && this.data.ToLat) {
      //   this.recalcDistance();       
      // }
      return f.long_name;
    }
    else return null;
  }

  public updateLocation(type: number, location: { description: string, address_components: google.maps.GeocoderAddressComponent[], addressWithComponents?: AddressWithComponents, lat: number, long: number }): Promise<boolean> {
    
    if (!this.data) return;

    return new Promise<boolean>((resolve, reject) => {

      try {
        let GoogleAddressTypeNames = {
          Country: 'country',
          Province: 'administrative_area_level_1',
          Town: 'locality',
          Suburb: 'sublocality',
          Street: 'route',
          StreetNumber: 'street_number',
          UnitNumber: "subpremise"
        };


        if (type == 0/*pick-up*/) {
          this.data.From = location.description;

          this.data.FromLat = location.lat;
          this.data.FromLong = location.long;

          if (location.addressWithComponents) {
            this.data.FromAddressComponents = location.addressWithComponents;
          }
          else {
      
            this.data.FromAddressComponents = new AddressWithComponents();

            if (location.address_components) {
              this.data.FromAddressComponents.Country = this.findAddressComponent(location.address_components, GoogleAddressTypeNames.Country);
              this.data.FromAddressComponents.Province = this.findAddressComponent(location.address_components, GoogleAddressTypeNames.Province);
              this.data.FromAddressComponents.Town = this.findAddressComponent(location.address_components, GoogleAddressTypeNames.Town);
              this.data.FromAddressComponents.Suburb = this.findAddressComponent(location.address_components, GoogleAddressTypeNames.Suburb);
              this.data.FromAddressComponents.Street = this.findAddressComponent(location.address_components, GoogleAddressTypeNames.Street);
              this.data.FromAddressComponents.StreetNumber = this.findAddressComponent(location.address_components, GoogleAddressTypeNames.StreetNumber);
              this.data.FromAddressComponents.UnitNumber = this.findAddressComponent(location.address_components, GoogleAddressTypeNames.UnitNumber);
            }
          }

        }
        else { // drop-off

          this.data.To = location.description;

          this.data.ToLat = location.lat;
          this.data.ToLong = location.long;

          if (location.addressWithComponents) {
            this.data.ToAddressComponents = location.addressWithComponents;
          }
          else {
            
            this.data.ToAddressComponents = new AddressWithComponents();

            if (location.address_components) {
              this.data.ToAddressComponents.Country = this.findAddressComponent(location.address_components, GoogleAddressTypeNames.Country);
              this.data.ToAddressComponents.Province = this.findAddressComponent(location.address_components, GoogleAddressTypeNames.Province);
              this.data.ToAddressComponents.Town = this.findAddressComponent(location.address_components, GoogleAddressTypeNames.Town);
              this.data.ToAddressComponents.Suburb = this.findAddressComponent(location.address_components, GoogleAddressTypeNames.Suburb);
              this.data.ToAddressComponents.Street = this.findAddressComponent(location.address_components, GoogleAddressTypeNames.Street);
              this.data.ToAddressComponents.StreetNumber = this.findAddressComponent(location.address_components, GoogleAddressTypeNames.StreetNumber);
              this.data.ToAddressComponents.UnitNumber = this.findAddressComponent(location.address_components, GoogleAddressTypeNames.UnitNumber);
            }
          }
        }

  
        // PL: Disabled to cut down on google maps costs
        if (this.data.FromLat && this.data.ToLat
            && (
                this.data.FromLatOld != this.data.FromLat ||
                this.data.FromLongOld != this.data.FromLong ||
                this.data.ToLatOld != this.data.ToLat ||
                this.data.ToLongOld != this.data.ToLong
              )
            ) {
          this.recalcDistance();
          
          if (type == 0/*pick-up*/) {
            this.data.FromLatOld = location.lat;
            this.data.FromLongOld = location.long;
          } else {
            this.data.ToLatOld = location.lat;
            this.data.ToLongOld = location.long;
          }
        }
        

        // force change detection otherwise google autocomplete bound inputs don't update
        //this.changeDetectorRef.detectChanges();
      }
      catch (e) {
        console.log(e);
      }

      resolve(true);

    });


  }

  public recalcDistance() {
    
      var fromLatLong = new google.maps.LatLng(this.data.FromLat, this.data.FromLong);
      var toLatLong = new google.maps.LatLng(this.data.ToLat, this.data.ToLong);

      
      // this.data.DistanceInKm = JSON.parse((google.maps.geometry.spherical.computeDistanceBetween(fromLatLong, toLatLong) / 1000.0).toFixed(2));
      

  
      
      this.isRecalcingDistance = false;



      this.isRecalcingDistance = true;

      var service = new google.maps.DistanceMatrixService();


      service.getDistanceMatrix({ origins: [fromLatLong], destinations: [toLatLong], travelMode: google.maps.TravelMode.DRIVING }, (response, status) => {

        this.isRecalcingDistance = false;

        // have to use zone.run otherwise change detection does not pick up the changes
        this.zone.run(() => {

          if (status == google.maps.DistanceMatrixStatus.OK) {

            if (response.rows.length > 0 && response.rows[0].elements.length > 0 && response.rows[0].elements[0].distance) {
              this.data.DistanceInKm = response.rows[0].elements[0].distance.value / 1000.0;


              

            }
          }
        });

        /*CHECK PAYAT STATUS*/
        let responseJson = null;
        let additionalJson = JSON.stringify({extraKm: this.data.DistanceInKm, source: "TmhUpdate", precalc: true});
       
        

        DAL.Icev0.pwa.TmhUpdate({
          pwaAppId: this.pwaService.pwa.appId,
          policyMemberGuid: this.profileService.policyMemberGuid,
          ioaRef: this.ioaRef,
          pickupDateLocal: <any>this.data.PickupDateTimeLocal/*L2.DAL will convert to GMT*/,
          numberOfPassengers: this.data.NumberOfPassengers,
          pickupLocation: this.data.From,
          pickupLat: this.data.FromLat,
          pickupLong: this.data.FromLong,
          dropOffLocation: this.data.To,
          dropOffLat: this.data.ToLat,
          dropOffLong: this.data.ToLong,
          contactNumber: this.data.ContactNo,
          contactPerson: this.data.ContactPerson,

          incidentCountry: this.data.FromAddressComponents.Country,
          incidentProvince: this.data.FromAddressComponents.Province,
          incidentTown: this.data.FromAddressComponents.Town,
          incidentSuburb: this.data.FromAddressComponents.Suburb,
          incidentStreetName: this.data.FromAddressComponents.Street,
          incidentStreetNumber: this.data.FromAddressComponents.StreetNumber,
          incidentUnitNumber: this.data.FromAddressComponents.UnitNumber,

          destinationCountry: this.data.ToAddressComponents.Country,
          destinationProvince: this.data.ToAddressComponents.Province,
          destinationTown: this.data.ToAddressComponents.Town,
          destinationSuburb: this.data.ToAddressComponents.Suburb,
          destinationStreetName: this.data.ToAddressComponents.Street,
          destinationStreetNumber: this.data.ToAddressComponents.StreetNumber,
          destinationUnitNumber: this.data.ToAddressComponents.UnitNumber,

          destinationLandmark: null,
          destinationNearestCorner: null,
          incidentLandmark: null,
          incidentNearestCorner: null,

          pickupLocationType: this.data.PickupLocationType,
          routedDistanceInKM: this.data.DistanceInKm,
          shortId: this.shortId,
          pickupNow: this.pickupNOW
        }).ExecQuery().then(r =>{

    

          if(r.Data.OutputParms.responseJson != null){

            if(r.Data.OutputParms.userErrorMsg != null){

                  L2.exclamation(r.Data.OutputParms.userErrorMsg);
            } else {

              let changesObject = JSON.parse(r.Data.OutputParms.responseJson)
  
              if(changesObject.changes == 'true'){
                if(changesObject.cancelled == 'true'){
                  /*KEEP NOTIFICATION UNTIL CHANGES HAVE BEEN SAVED AGAINST IOA*/

                  this.pwaService.pwa.changeUserAttention(null);
                }
                else if(changesObject.cancelled == 'false') {

                  this.pwaService.pwa.changeUserAttention('{"userAttentionMsg": "Changes will reflect upon saving"}')
                } else {
                  DAL.Icev0.pwa.UserAttentionActionGet({pwaAppId: this.pwaService.pwa.appId
                    ,policyMemberGuid: this.pwaService.pwa.policyMemberGuid
                    ,ioaRef: this.ioaRef
                    ,shortId: this.shortId})
                  .ExecQuery().then(r=>{
  
                  // this.pwaService.pwa.UserAttention$.next(r.Data.OutputParms.forUserAttention);

                    this.pwaService.pwa.changeUserAttention(r.Data.OutputParms.forUserAttention);
                });
                }
                              
              }
            }
          }           
        });
        // DAL.Icev0.pwa.PayatReEvaluate({additionalJson: additionalJson
        //                               , responseJson: responseJson
        //                               , ioaRef: this.ioaRef})
        // .ExecQuery().then((r)=>{
        //   if(r.Data.OutputParms.userErrorMsg != null){
        //     L2.exclamation(r.Data.OutputParms.userErrorMsg);
        //   } else {
        //     let changesObject = JSON.parse(r.Data.OutputParms.responseJson)

        //     if(changesObject.changes == 'true'){
        //       if(changesObject.cancelled == 'true'){
        //         /*KEEP NOTIFICATION UNTIL CHANGES HAVE BEEN SAVED AGAINST IOA*/
        //         this.pwaService.pwa.changeUserAttention(null);
        //       }
        //       else if(changesObject.cancelled == 'false') {
        //         this.pwaService.pwa.changeUserAttention('{"userAttentionMsg": "Changes will reflect upon saving"}')
        //       } else {
        //         DAL.Icev0.pwa.UserAttentionActionGet({pwaAppId: this.pwaService.pwa.appId
        //           ,policyMemberGuid: this.pwaService.pwa.policyMemberGuid
        //           ,ioaRef: this.ioaRef
        //           ,shortId: this.shortId})
        //         .ExecQuery().then(r=>{

        //         // this.pwaService.pwa.UserAttention$.next(r.Data.OutputParms.forUserAttention);
        //           this.pwaService.pwa.changeUserAttention(r.Data.OutputParms.forUserAttention);
        //       });
        //       }
                           
        //     }
        //   }
        // });
      });       
  }
}
